// extracted by css-extract-rspack-plugin
export default {"secureCheckout":"header-fragment__SecureCheckout_secureCheckout__y9v65"};